import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 border-t border-gray-800 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-between gap-3">
        <div className="flex items-center text-sm">
          <Shield className="h-5 w-5 mr-2 text-blue-400" aria-hidden="true" />
          <span>Maphra by Dedsec<sup className="ml-0.5 text-[10px]">™</sup></span>
          <span className="mx-2">•</span>
          <span>© {new Date().getFullYear()} Dedsec Technologies LLP. All rights reserved.</span>
        </div>
        <div className="flex items-center gap-4 text-sm">
          <Link to="/terms" className="hover:text-white">Terms</Link>
          <Link to="/privacy" className="hover:text-white">Privacy</Link>
          <a href="mailto:contact@dedsecops.com" className="hover:text-white">contact@dedsecops.com</a>
          <a href="tel:+918750001998" className="hover:text-white">+91 87500 01998</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

